export const SHOWCASE_INDEX_TITLE = 'Выбирайте и покупайте путешествия онлайн';
